import React from 'react';
import * as PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import WbIcon from '../Common/WbIcon';
import Button from 'react-bootstrap/Button';

const renderIcon = (renderer, iconName) => {
  switch (renderer) {
    case 'fa':
      if (iconName.indexOf('-o') >= 0) {
        iconName = iconName.substring(0, iconName.length - 2);
      }
      return <FontAwesomeIcon icon={['far', iconName]} size="1x" />;
    case 'wb':
      if (iconName.indexOf('wb-') === 0) {
        iconName = iconName.substring(3);
      }
      return <WbIcon icon={iconName} />;
    default:
      return null;
  }
};

const WorkAreaInputButton = ({ label, icon, active, clickHandler }) => {
  const variant = active ? 'wb' : 'outline-secondary';

  let iconRender = 'fa';
  if (icon !== null) {
    if (icon.indexOf('fa fa-') === 0) {
      icon = icon.substring(6);
    } else if (icon.indexOf('wb ') >= 0) {
      iconRender = 'wb';
      icon = icon.substring(3);
    }
    return (
      <Button
        variant={variant}
        title={label}
        onClick={clickHandler}
        size="sm"
        className="pt-1 fs-6"
        aria-pressed={active}
      >
        {renderIcon(iconRender, icon)}
      </Button>
    );
  } else {
    return (
      <Button variant={variant} title={label} onClick={clickHandler} size="sm" aria-pressed={active}>
        {label}
      </Button>
    );
  }
};

// some of these are only used in the container
WorkAreaInputButton.propTypes = {
  label: PropTypes.string,
  action: PropTypes.string,
  params: PropTypes.object,
  type: PropTypes.string,
  node: PropTypes.string,
  active: PropTypes.bool,
  clickHandler: PropTypes.func,
};

WorkAreaInputButton.defaultProps = {
  label: 'Button Label',
  action: null,
  icon: null,
  params: {},
  type: 'default',
  active: false,
};

export default WorkAreaInputButton;
